let domLoaded = false;
let igReady = false;

function handleExperiments() {
  if (!domLoaded || !igReady) return;

  cartUpsellBlackInit();

  // Test: V_CC_PDP_27 | Compression Guide Popup on PDP
  const pdp27 = window.igData?.user.getTestGroup(
    "f3586f43-04d0-4218-a005-675eea7eca33"
  );

  if (pdp27?.name === "Var A") {
    document.body.classList.add("c-pdp27VarA");
  }

  // Test: V_CC_CART_29 | 3 Pair Bundle - Multi Color Pair Upsell
  const cart29 = window.igData?.user.getTestGroup(
    "2299e25a-3416-4497-a824-24f00285b54c"
  );

  if (cart29?.name === "Var A - Flat Fee") {
    document.body.classList.add("c-cart29VarA");
  } else if (cart29?.name === "Var B - Percent Off") {
    document.body.classList.add("c-cart29VarB");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  domLoaded = true;
  handleExperiments();
});

window.addEventListener("ig:ready", () => {
  igReady = true;
  handleExperiments();
});
